import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextLinkButton } from 'components/buttons/TextLinkButton';
import { Color } from 'core';
import styled from 'styled-components';

export const filterChipSx = {
  borderRadius: '16px',
  borderColor: Color.primaryBlue,
  color: Color.primaryBlue,
};

export const FilterButtonWrapper = styled.div`
  position: relative;
`;

export const FilterButton = styled.button<{ $hasActiveFilters: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.8rem 1.2rem;
  background-color: ${(props) => (props.$hasActiveFilters ? Color.ceregoGreen : 'white')};
  color: ${(props) => (props.$hasActiveFilters ? 'white' : Color.primaryBlack)};
  border: 1px solid ${(props) => (props.$hasActiveFilters ? Color.ceregoGreen : Color.lightGray)};
  border-radius: 0.25em;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) => (props.$hasActiveFilters ? Color.darkGreen : Color.primaryGray)};
  }
`;

export const FilterDropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid ${Color.lightGray};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 280px;
  padding: 16px;
`;

export const FilterSection = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FilterSectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${Color.textGray};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const FilterOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: ${Color.primaryBlack};

  &:hover {
    color: ${Color.primaryBlue};
  }

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const FilterChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
`;

export const ClearAllFiltersButton = styled(TextLinkButton)`
  font-size: 13px;
  margin-left: 8px;
`;

export const LoadingSpinner = styled(FontAwesomeIcon).attrs({ icon: faSpinner, spin: true })`
  color: ${Color.textGray};
  font-size: 14px;
  margin-left: 8px;
`;
